import { Component, Input, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { SelectInputOptionInterface } from '@vendasta/galaxy/input';
import { DynamicOptionsComponent } from '../dynamic-options';
import { ACCOUNT_GROUP_ORIGIN_OPTIONS } from './account-group-origin-options';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-account-group-origin-options',
  templateUrl: './account-group-origin-options.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class AccountGroupOriginOptionsComponent implements OnInit, DynamicOptionsComponent {
  originOptionControl: UntypedFormControl = new UntypedFormControl('');
  originOptions = ACCOUNT_GROUP_ORIGIN_OPTIONS;
  originSelectOptions: SelectInputOptionInterface[];

  @Input() initialValue: string[];
  selectedValue$ = this.originOptionControl.valueChanges;

  constructor(private readonly translateService: TranslateService) {}

  ngOnInit(): void {
    const initialValue = this.initialValue && this.initialValue[0];
    this.originOptionControl.setValue(initialValue || this.originOptions[0].value);
    this.originSelectOptions = this.originOptions.map((option) => ({
      label: this.translateService.instant(option.label),
      value: option.value,
      selected: option.value === this.originOptionControl?.value,
    }));
  }

  getSelectedValue(): string[] {
    return [this.originOptionControl?.value];
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.originOptionControl];
  }

  isFormValid(): boolean {
    return true;
  }
}
